import React from 'react';
import { CrudPage } from '@restavo/crud';
import { useEmployeesPage } from 'src/features/employees';

const AllEmployees = React.memo(() => {
  const { page, inviteModal, deactivateModal, revokeFailureNotices } = useEmployeesPage();
  return (
    <>
      <CrudPage {...page} />
      {inviteModal}
      {deactivateModal}
      {revokeFailureNotices}
    </>
  );
});

export default AllEmployees;
